import { inspectPhotoFiles, type RefusedPhoto } from '@/entities/photo';

/**
 * Wat er met de laatste selectie misging. Eén lijst voor de hele opname: je
 * voegt foto's aan één vraag tegelijk toe, en een nieuwe selectie vervangt de
 * vorige melding.
 */
let refused: readonly RefusedPhoto[] = [];

const listeners = new Set<() => void>();

/**
 * Elke fotoknop kan de melding tonen, maar hij verschijnt één keer: de eerst
 * gemonteerde kaart is de gastheer. De melding staat vast op het scherm, dus
 * waar in de boom hij hangt maakt visueel niets uit.
 */
const hosts: object[] = [];

function emit(): void {
    for (const listener of listeners) {
        listener();
    }
}

export function subscribeToPhotoIntake(listener: () => void): () => void {
    listeners.add(listener);

    return () => {
        listeners.delete(listener);
    };
}

export function refusedPhotos(): readonly RefusedPhoto[] {
    return refused;
}

/**
 * De eerste kaart van een opname begint schoon: een melding van een vorige
 * opname hoort niet bij deze vragen.
 */
export function claimNoticeHost(token: object): () => void {
    if (hosts.length === 0) {
        refused = [];
    }

    hosts.push(token);
    emit();

    return () => {
        const at = hosts.indexOf(token);

        if (at >= 0) {
            hosts.splice(at, 1);
        }

        emit();
    };
}

export function isNoticeHost(token: object): boolean {
    return hosts[0] === token;
}

/**
 * De ene weg waarlangs gekozen, gefotografeerde en gesleepte bestanden
 * binnenkomen.
 *
 * Elk bestand wordt apart bekeken: **één bestand dat niet meekan houdt de rest
 * niet tegen**. Wat door mag gaat meteen naar de opname; wat niet door mag komt
 * per bestand in beeld, met wat je eraan kunt doen.
 */
export async function takePhotoFiles(
    files: readonly File[],
    onAccepted: (files: File[]) => void,
): Promise<void> {
    if (files.length === 0) {
        return;
    }

    const intake = await inspectPhotoFiles(files);

    refused = intake.refused;
    emit();

    if (intake.accepted.length > 0) {
        onAccepted(intake.accepted);
    }
}

/** Het sluiten van de melding, en het schoonvegen tussen twee tests. */
export function dismissRefusedPhotos(): void {
    refused = [];
    emit();
}
